<nz-layout class="app-layout">
  <nz-sider *ngIf="authService.isLoggedIn()" class="menu-sidebar hide-side-bar" nzCollapsible nzWidth="275px"
    nzBreakpoint="md" [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">
    <div class="sidebar-logo">
      <nz-space [nzSize]="15" style="height: 100%; display: flex; align-items: center;">
        <img *nzSpaceItem src="/assets/images/logo.png" alt="logo">
        <div class="logo-text" *nzSpaceItem>
          <span class="h1">Payment Monitoring</span>
          <div style="color: #636566; letter-spacing: 4px;">Charging act</div>
        </div>
      </nz-space>
    </div>
    <nz-divider></nz-divider>


    <ul class="sidebar-overflow" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li *ngIf="isInRoles(['Admin'])" nz-submenu nzOpen nzTitle="Dashboard" nzIcon="dashboard">
        <ul>
          <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.dashboard">
            <a [routerLink]="item.path">{{item.label}}</a>
          </li>
        </ul>
      </li>
      <li *ngIf="isInRoles(['Admin', 'Cloud7'])" nz-submenu nzOpen nzTitle="Configuration" nzIcon="setting">
        <ul>
          <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.configuration">
            <a [routerLink]="item.path">{{item.label}}</a>
          </li>
        </ul>
      </li>
      <li *ngIf="isInRoles(['Admin']) && menuConfig.notifyVendor" nz-submenu nzOpen nzTitle="Notify Vendor"
        nzIcon="notification">
        <ul>
          <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.notifyVendor">
            <a [routerLink]="item.path">{{item.label}}</a>
          </li>
        </ul>
      </li>
      <li *ngIf="isInRoles(['Admin'])" nz-submenu nzOpen nzTitle="Notify Ads Vendor" nzIcon="notification">
        <ul>
          <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.notifyAdsVendor">
            <a [routerLink]="item.path">{{item.label}}</a>
          </li>
        </ul>
      </li>
      <li *ngIf="isInRoles(['Admin'])" nz-submenu nzOpen nzTitle="Charging Nofity" nzIcon="notification">
        <ul>
          <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.chargingNofity">
            <a [routerLink]="item.path">{{item.label}}</a>
          </li>
        </ul>
      </li>
      <li *ngIf="isInRoles(['Admin']) && menuConfig.others" nz-submenu nzOpen nzTitle="Others" nzIcon="plus-circle">
        <ul>
          <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.others">
            <a [routerLink]="item.path">{{item.label}}</a>
          </li>
        </ul>
      </li>
      <li *ngIf="isInRoles(['Admin', 'Cloud7','Reporter'])" nz-submenu nzOpen nzTitle="Reporting" nzIcon="plus-circle">
        <ul>
          <ng-container  *ngFor="let item of menuConfig.reporting">
            <li *ngIf="isInRoles(item.roles)" nz-menu-item nzMatchRouter>
              <a [routerLink]="item.path">{{item.label}}</a>
            </li>
          </ng-container>

        </ul>
      </li>
    </ul>

  </nz-sider>

  <!-- Start :: Drawer -->
  <nz-drawer [nzClosable]="false" [nzVisible]="visible" nzPlacement="left" (nzOnClose)="close()">
    <ng-container *nzDrawerContent>
      <nz-sider *ngIf="authService.isLoggedIn()" class="menu-sidebar" nzWidth="275px" [nzTrigger]="null">
        <div class="sidebar-logo">
          <nz-space [nzSize]="15"
            style="height: 100%; display: flex; align-items: center;justify-content: space-around;">
            <img *nzSpaceItem src="/assets/images/logo.png" alt="logo">
            <div class="logo-text" *nzSpaceItem>
              <span class="h1">Payment Monitoring</span>
              <div style="color: #636566; letter-spacing: 4px;">Charging act</div>
            </div>
            <div *nzSpaceItem class="drawer-close-icon">
              <span nz-icon nzType="close-circle" nzTheme="fill" (click)="close()"></span>
            </div>
          </nz-space>

        </div>

        <nz-divider></nz-divider>


        <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
          <li *ngIf="isInRoles(['Admin'])" nz-submenu nzOpen nzTitle="Dashboard" nzIcon="dashboard">
            <ul>
              <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.dashboard">
                <a [routerLink]="item.path">{{item.label}}</a>
              </li>
            </ul>
          </li>
          <li *ngIf="isInRoles(['Admin', 'Cloud7'])" nz-submenu nzOpen nzTitle="Configuration" nzIcon="setting">
            <ul>
              <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.configuration">
                <a [routerLink]="item.path">{{item.label}}</a>
              </li>
            </ul>
          </li>
          <li *ngIf="isInRoles(['Admin']) && menuConfig.notifyVendor" nz-submenu nzOpen nzTitle="Notify Vendor"
            nzIcon="notification">
            <ul>
              <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.notifyVendor">
                <a [routerLink]="item.path">{{item.label}}</a>
              </li>
            </ul>
          </li>
          <li *ngIf="isInRoles(['Admin'])" nz-submenu nzOpen nzTitle="Notify Ads Vendor" nzIcon="notification">
            <ul>
              <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.notifyAdsVendor">
                <a [routerLink]="item.path">{{item.label}}</a>
              </li>
            </ul>
          </li>
          <li *ngIf="isInRoles(['Admin'])" nz-submenu nzOpen nzTitle="Charging Nofity" nzIcon="notification">
            <ul>
              <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig.chargingNofity">
                <a [routerLink]="item.path">{{item.label}}</a>
              </li>
            </ul>
          </li>
          <li *ngIf="isInRoles(['Admin']) && menuConfig.others" nz-submenu nzOpen nzTitle="Others" nzIcon="plus-circle">
            <ul>
              <li nz-menu-item nzMatchRouter *ngFor="let item of menuConfig?.others">
                <a [routerLink]="item.path">{{item.label}}</a>
              </li>
            </ul>
          </li>
          <li *ngIf="isInRoles(['Admin', 'Cloud7','Reporter'])" nz-submenu nzOpen nzTitle="Reporting" nzIcon="plus-circle">
            <ul>
              <ng-container  *ngFor="let item of menuConfig.reporting">
                <li *ngIf="isInRoles(item.roles)" nz-menu-item nzMatchRouter>
                  <a [routerLink]="item.path">{{item.label}}</a>
                </li>
              </ng-container>
    
            </ul>
          </li>
        </ul>

      </nz-sider>

    </ng-container>

  </nz-drawer>
  <!-- End :: Drawer -->


  <nz-layout>
    <nz-header>
      <div nz-row nzJustify="space-between" class="app-header">
        <div nz-col nzSpan="auto">
          <div *ngIf="!authService.isLoggedIn()" class="sidebar-logo">
            <nz-space [nzSize]="15" style="height: 100%; display: flex; align-items: center;">
              <img *nzSpaceItem src="/assets/images/logo.png" alt="logo">
              <div *nzSpaceItem>
                <span class="h1">Payment Monitoring</span>
                <div style="color: #636566; letter-spacing: 4px;">Shadhin music</div>
              </div>
            </nz-space>

          </div>
          <span *ngIf="authService.isLoggedIn()" class="header-trigger hide-side-bar"
            (click)="isCollapsed = !isCollapsed">
            <span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
          </span>
          <!-- Start :: Drawer controll -->
          <span *ngIf="authService.isLoggedIn()" class="header-trigger show-tab-side-bar" (click)="open()">
            <span class="trigger" nz-icon [nzType]="visible ? 'menu-unfold' : 'menu-fold'"></span>
          </span>
          <!-- End :: Drawer controll  -->
        </div>
        <div nz-col nzSpan="auto" class="vertically-center">
          <button *ngIf="authService.isLoggedIn()" (click)="logout()" class="btn-logout">
            Logout
          </button>
          <button *ngIf="!authService.isLoggedIn()" class="btn-login">
            Login
          </button>
        </div>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>